import { render, staticRenderFns } from "./DatePeriodPicker.vue?vue&type=template&id=05bbc3e8&"
import script from "./DatePeriodPicker.vue?vue&type=script&lang=ts&"
export * from "./DatePeriodPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports